"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerformerItemOverlay = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var RaisedButton_1 = __importDefault(require("@atg/icf-react-components/components/RaisedButton"));
var SvgIcon_1 = __importDefault(require("@atg/icf-react-components/components/SvgIcon/SvgIcon"));
var XmentService_1 = require("icf-search-client-shared/lib/services/XmentService");
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var PerformerItemInfoBar_1 = require("./PerformerItemInfoBar");
var PerformerItemLabels_1 = require("./PerformerItemLabels");
var getStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    cover: {
        alignItems: "center",
        boxSizing: "border-box",
        color: theme.colors.textOnDark,
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "center",
        // eslint-disable-next-line @atg/css-rtl-support
        left: 0,
        padding: theme.spacing.base,
        position: "absolute",
        textAlign: "center",
        top: 0,
        width: "100%",
    },
    offlineCover: {
        background: "rgba(33, 33, 33, 0.5)",
        color: theme.colors.textOnDark,
        textTransform: "uppercase",
    },
    unavailableCover: {
        background: "rgba(0, 0, 0, 0.6)",
        paddingBottom: "25px",
    },
    messagePrimary: {
        fontSize: "16px",
    },
    ctaButton: {
        margin: theme.spacing.base,
        fontSize: "14px",
    },
    liveBugContainer: {
        position: "absolute",
        top: "5px",
        insetInlineStart: "5px",
    },
    /* eslint-disable @atg/css-rtl-support */
    mobileIconContainer: {
        position: "absolute",
        bottom: "36px",
        right: "4px",
        zIndex: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    /* eslint-enable  @atg/css-rtl-support */
}); });
var useTranslateAndClasses = function () {
    var _a = __read((0, Ioc_1.useContexts)(Contexts_1.ITranslationServiceContext), 1), translate = _a[0].translate;
    var theme = (0, react_jss_1.useTheme)();
    var classes = getStyles({ theme: theme });
    return { translate: translate, classes: classes };
};
var OfflineOverlay = function () {
    var _a = useTranslateAndClasses(), translate = _a.translate, classes = _a.classes;
    return (react_1.default.createElement("div", { className: "".concat(classes.cover, " ").concat(classes.offlineCover), "data-ta-locator": "search.offline" }, translate("search.offline")));
};
var OnBreakOverlay = function (_a) {
    var onNotifyClicked = _a.onNotifyClicked;
    var _b = useTranslateAndClasses(), translate = _b.translate, classes = _b.classes;
    return (react_1.default.createElement("div", { className: "".concat(classes.cover, " ").concat(classes.unavailableCover), "data-ta-locator": "search.onbreak" },
        react_1.default.createElement("div", { className: classes.messagePrimary }, translate("search.on_break")),
        react_1.default.createElement(RaisedButton_1.default, { "data-ta-locator": "search.notifyButton", size: "small", className: classes.ctaButton, label: translate("search.notify_when_back"), onClick: onNotifyClicked })));
};
var ExclusiveShowOverlay = function (_a) {
    var onNotifyClicked = _a.onNotifyClicked;
    var _b = useTranslateAndClasses(), translate = _b.translate, classes = _b.classes;
    return (react_1.default.createElement("div", { className: "".concat(classes.cover, " ").concat(classes.unavailableCover), "data-ta-locator": "search.exclusive" },
        react_1.default.createElement("div", { className: classes.messagePrimary }, translate("search.exclusive")),
        react_1.default.createElement(RaisedButton_1.default, { "data-ta-locator": "search.notifyButton", className: classes.ctaButton, size: "small", label: translate("search.notify_when_back"), onClick: onNotifyClicked })));
};
var PrivateChatOverlay = function () {
    var _a = useTranslateAndClasses(), translate = _a.translate, classes = _a.classes;
    return (react_1.default.createElement("div", { className: "".concat(classes.cover, " ").concat(classes.unavailableCover), "data-ta-locator": "search.private" },
        react_1.default.createElement("div", { className: classes.messagePrimary }, translate("search.performing_live")),
        react_1.default.createElement(RaisedButton_1.default, { className: classes.ctaButton, size: "small", label: translate("search.join_show") })));
};
var GoldShowOverlay = function () {
    var _a = useTranslateAndClasses(), translate = _a.translate, classes = _a.classes;
    return (react_1.default.createElement("div", { className: "".concat(classes.cover, " ").concat(classes.unavailableCover), "data-ta-locator": "search.goldshow" },
        react_1.default.createElement("div", { className: classes.messagePrimary }, translate("search.performing_live")),
        react_1.default.createElement(RaisedButton_1.default, { className: classes.ctaButton, size: "small", label: translate("search.join_show"), gold: true })));
};
var OverlayContent = function (_a) {
    var isHovering = _a.isHovering, online = _a.online, onBreak = _a.onBreak, exclusiveShow = _a.exclusiveShow, privateChat = _a.privateChat, goldShow = _a.goldShow, preGoldShow = _a.preGoldShow, onNotifyClicked = _a.onNotifyClicked;
    if (!online) {
        return react_1.default.createElement(OfflineOverlay, null);
    }
    if (!isHovering) {
        return null;
    }
    if (onBreak) {
        return react_1.default.createElement(OnBreakOverlay, { onNotifyClicked: onNotifyClicked });
    }
    if (exclusiveShow) {
        return react_1.default.createElement(ExclusiveShowOverlay, { onNotifyClicked: onNotifyClicked });
    }
    if (privateChat) {
        return react_1.default.createElement(PrivateChatOverlay, null);
    }
    if (goldShow && !preGoldShow) {
        return react_1.default.createElement(GoldShowOverlay, null);
    }
    return null;
};
var mobileCategories = ["mobile", "tsmobile", "mobileguy"];
var PerformerItemOverlay = function (_a) {
    var _b, _c;
    var performerData = _a.performerData, isHovering = _a.isHovering, previewLoading = _a.previewLoading, onFavoriteIconClicked = _a.onFavoriteIconClicked, onNotifyClicked = _a.onNotifyClicked, showHeadline = _a.showHeadline;
    var _d = performerData.liveState, specialShow = _d.specialShow, goldShow = _d.goldShow, preGoldShow = _d.preGoldShow, onBreak = _d.onBreak, exclusiveShow = _d.exclusiveShow, privateChat = _d.privateChat;
    var online = performerData.online;
    var classes = getStyles({ theme: (0, react_jss_1.useTheme)() });
    var _e = __read((0, Ioc_1.useContexts)(Contexts_1.IXmentServiceContext), 1), xmentService = _e[0];
    var showType = specialShow ? "specialShow" : goldShow || preGoldShow ? "goldShow" : undefined;
    var streamingOnMobile = (_c = (_b = performerData.categoryName) === null || _b === void 0 ? void 0 : _b.some(function (category) { return mobileCategories.includes(category.toLowerCase()); })) !== null && _c !== void 0 ? _c : false;
    var showMobileIcon = streamingOnMobile && (xmentService === null || xmentService === void 0 ? void 0 : xmentService.isXmentVariationOn(XmentService_1.SEARCH_ENABLE_PERFORMER_MOBILE_ICON));
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(OverlayContent, { isHovering: isHovering, online: online, onBreak: onBreak, exclusiveShow: exclusiveShow, privateChat: !!privateChat, goldShow: goldShow, preGoldShow: preGoldShow, onNotifyClicked: onNotifyClicked }),
        react_1.default.createElement(PerformerItemInfoBar_1.PerformerItemInfoBar, { age: performerData.age, country: performerData.country, isFavorite: performerData.favorite, isHovering: isHovering, isOnline: online, nickname: performerData.nickname, previewLoading: previewLoading, stars: performerData.stars, onFavoriteIconClicked: onFavoriteIconClicked, headline: (showHeadline && performerData.headlineMessage) || "", performerData: performerData }),
        react_1.default.createElement(PerformerItemLabels_1.PerformerItemLabels, { isNew: performerData.new, showType: showType, hasVibe: performerData.toyEnabled, hasVoip: performerData.voipAvailable }),
        showMobileIcon && (react_1.default.createElement("div", { className: classes.mobileIconContainer, "data-ta-locator": "PerformerItemOverlay-mobileIcon" },
            react_1.default.createElement(SvgIcon_1.default, { name: "smartphone", size: "small", fill: "baseContrast100", dropShadow: true })))));
};
exports.PerformerItemOverlay = PerformerItemOverlay;
exports.PerformerItemOverlay.displayName = "PerformerItemOverlay";
//# sourceMappingURL=PerformerItemOverlay.js.map